module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_delete-7a1aff05a9f18ad14293d36f63495c15.png";